import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import Aux from "../../../../../hoc/Auxilary";
import SelectionFields from "../../../../../hoc/UI/SelectionFields/SelectionFields";
import { Button } from "rsuite";

class ContractWorkZoneForm extends Component {
  render() {
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        if (Object.keys(errors).length !== 0) {
          this.props.setFieldTouched("proj_contract_id", true);
          this.props.setFieldTouched("aadt", true);
          this.props.setFieldTouched("crash_rate", true);
          this.props.setFieldTouched("posted_travel_speed", true);
          console.log("cannot submit! Validation failed", errors);
        } else {
          values.project_id = this.props.projectID;
          func(values);
          this.props.resetForm();
          this.props.toggleSmallModalHandler();
        }
      });
    };

    return (
      <Form>
        {" "}
        <fieldset disabled={this.props.disabled}>
          {" "}
          <div
            onClick={this.props.toggleSmallModalHandler}
            style={{ color: "red", float: "right", cursor: "pointer" }}
          >
            x
          </div>
          <small className={"d-block col-12"}>
            <span style={{ color: "red" }}>*</span> required
          </small>
          <label
            className="col-12"
            style={
              this.props.errors.aadt &&
              this.props.touched.aadt && { color: "red" }
            }
          >
            AADT
            <Field
              className="form-control-sm form-control"
              name={"aadt"}
              value={this.props.values.aadt || null}
            />
            {this.props.errors.aadt && this.props.touched.aadt && (
              <small className="text-danger">{this.props.errors.aadt}</small>
            )}
          </label>
          <label
            className="col-12"
            style={
              this.props.errors.crash_rate &&
              this.props.touched.crash_rate && { color: "red" }
            }
          >
            Crash Rate
            <Field
              className="form-control-sm form-control"
              name={"crash_rate"}
              value={this.props.values.crash_rate || null}
            />
            {this.props.errors.crash_rate && this.props.touched.crash_rate && (
              <small className="text-danger">
                {this.props.errors.crash_rate}
              </small>
            )}
          </label>
          <label
            className="col-12"
            style={
              this.props.errors.posted_travel_speed &&
              this.props.touched.posted_travel_speed && { color: "red" }
            }
          >
            Posted Travel Speed
            <Field
              className="form-control-sm form-control"
              name={"posted_travel_speed"}
              value={this.props.values.posted_travel_speed || null}
            />
            {this.props.errors.posted_travel_speed &&
              this.props.touched.posted_travel_speed && (
                <small className="text-danger">
                  {this.props.errors.posted_travel_speed}
                </small>
              )}
          </label>
          <div>
            <SelectionFields
              showError={
                this.props.errors.proj_contract_id &&
                this.props.touched.proj_contract_id
              }
              size={"col-12"}
              id={"proj_contract_id"}
              url={`proj_contract/project_id/${this.props.projectID}`}
              showElem={"contract_name"}
              label={"Contract"}
              value={this.props.values["proj_contract_id"] || "default"}
              isRequired={true}
              errorMessage={
                this.props.errors.proj_contract_id &&
                this.props.touched.proj_contract_id && (
                  <small className={"text-danger"}>
                    {this.props.errors.proj_contract_id}
                  </small>
                )
              }
            />
          </div>
          <label className="col-12">
            Location
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"location"}
              value={this.props.values.location || ""}
            />
          </label>
          <label className="col-12">
            Notes
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"notes"}
              value={this.props.values.notes || ""}
            />
          </label>
          <label className="col-12">
            Traffic Control
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"traffic_control"}
              value={this.props.values.traffic_control || ""}
            />
          </label>
        </fieldset>
        {this.props.disabled ? (
          <Button
            className={"ml-2"}
            type="button"
            onClick={this.props.toggleSmallModalHandler}
          >
            Cancel
          </Button>
        ) : (
          <div>
            {!this.props.currentContractWorkZone ? (
              <Aux>
                <Button
                  color={"blue"}
                  type="button"
                  onClick={() => {
                    validAndHandle(this.props.add, this.props.values);
                  }}
                >
                  Submit
                </Button>
                <Button
                  className={"ml-2"}
                  color={"red"}
                  type="button"
                  onClick={this.props.handleReset}
                >
                  Reset
                </Button>
              </Aux>
            ) : (
              <Aux>
                <Button
                  color={"blue"}
                  type="button"
                  onClick={() => {
                    validAndHandle(this.props.update, this.props.values);
                  }}
                >
                  Update
                </Button>
                <Button
                  color={"red"}
                  className={"ml-2"}
                  type="button"
                  onClick={this.props.handleReset}
                >
                  Reset
                </Button>
              </Aux>
            )}
            <Button
              className={"ml-2"}
              type="button"
              onClick={this.props.toggleSmallModalHandler}
            >
              Cancel
            </Button>
          </div>
        )}
      </Form>
    );
  }
}

var contractWorkZoneSchema = Yup.object().shape({
  proj_contract_id: Yup.number().required(),
  aadt: Yup.number()
    .nullable()
    .typeError("Number required"),
  crash_rate: Yup.number()
    .nullable()
    .typeError("Number required"),
  posted_travel_speed: Yup.number()
    .nullable()
    .typeError("Number required")
});

export default withFormik({
  validationSchema: contractWorkZoneSchema,
  enableReinitialize: true,

  mapPropsToValues({ currentContractWorkZone }) {
    return {
      ...currentContractWorkZone
    };
  }
})(ContractWorkZoneForm);
